import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsHomebridgeComponent } from './simple-icons-homebridge.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsHomebridgeComponent ],
    exports:      [ SimpleIconsHomebridgeComponent ],
    bootstrap:    []
})
export class SimpleIconsHomebridgeModule {}
